import { useState } from "react";
import { useNavigate } from "react-router-dom";

//MUI
import {
  AppBar,
  Box,
  Button,
  IconButton,
  styled,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import { Instagram as InstagramIcon } from "@mui/icons-material";

//Components
import logo from "../../../../images/volt_logo.jpg";
import { HEADER_COLOR } from "../../../../theme/theme";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  height: "100px",
});
const NAVBAR_LINKS = [
  { label: "Accueil", path: "/" },
  { label: "COURS", path: "/cours" },
  { label: "INSTRUCTEURS", path: "/instructeurs" },
  { label: "GALERIE", path: "/galerie" },
  { label: "CONTACT", path: "/contact" },
];

const NAV_TEXT_COLOR = "#ffffff";

export function NavBarSmall() {
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();

  const handleNavClick = (link: string) => {
    navigate(link);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setOpenMenu(false);
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: HEADER_COLOR }}>
      <StyledToolbar disableGutters sx={{ pr: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          width="100%"
        >
          <Button
            variant="text"
            disableElevation
            sx={{
              p: 0,
              minWidth: 0,
              color: NAV_TEXT_COLOR,
              "&:hover": {
                color: alpha(NAV_TEXT_COLOR, 0.6),
              },
            }}
            onClick={() => {
              handleNavClick("/");
            }}
          >
            <Box component="img" src={logo} height="100px" alt="Volt BJJ" />
          </Button>

          <Box display="flex" alignItems="center">
            <IconButton
              sx={{
                color: NAV_TEXT_COLOR,
                "&:hover": {
                  color: alpha(NAV_TEXT_COLOR, 0.6),
                  cursor: "pointer",
                },
              }}
              onClick={() => window.open("https://www.instagram.com/volt.bjj")}
            >
              <InstagramIcon />
            </IconButton>

            <IconButton
              sx={{
                color: NAV_TEXT_COLOR,
                "&:hover": {
                  color: alpha(NAV_TEXT_COLOR, 0.6),
                  cursor: "pointer",
                },
              }}
              onClick={() => setOpenMenu(true)}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Box>
      </StyledToolbar>
      {openMenu && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="flex-start"
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: HEADER_COLOR,
            zIndex: theme.zIndex.modal,
            overflowY: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            gap: 1,
          }}
        >
          {NAVBAR_LINKS.map((item) => (
            <Button
              key={item.path}
              variant="text"
              disableElevation
              sx={{
                color: NAV_TEXT_COLOR,
                "&:hover": { color: alpha(NAV_TEXT_COLOR, 0.6) },
              }}
              onClick={() => handleNavClick(item.path)}
            >
              <Typography variant="h4" fontSize="7vmin">
                {item.label}
              </Typography>
            </Button>
          ))}
        </Box>
      )}
    </AppBar>
  );
}
